export default __webpack_public_path__ + "static/media/themeSong.4f2075ff.wav";